module.exports = __webpack_public_path__ + "static/liquor16-b09d16fc2a49c3ebe85fd2d4995ed9f4.jpg";